// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Recharts = require("recharts");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var JsxRuntime = require("react/jsx-runtime");
var AxisData$ReactHooksTemplate = require("./axisData.res.js");
var DataWindowSettings$ReactHooksTemplate = require("./dataWindowSettings.res.js");
var GenericChartAttribute$ReactHooksTemplate = require("./genericChartAttribute.res.js");

function startIndex(settings, dataLength) {
  var match = DataWindowSettings$ReactHooksTemplate.type_(settings);
  if (match === "All") {
    return 0;
  }
  var match$1 = DataWindowSettings$ReactHooksTemplate.initialFocus(settings);
  if (match$1 === "FirstWindow" || (dataLength - DataWindowSettings$ReactHooksTemplate.size(settings) | 0) <= 0) {
    return 0;
  } else {
    return dataLength - DataWindowSettings$ReactHooksTemplate.size(settings) | 0;
  }
}

function endIndex(settings, dataLength) {
  var match = DataWindowSettings$ReactHooksTemplate.type_(settings);
  if (match === "All") {
    if (dataLength === 0) {
      return 0;
    } else {
      return dataLength - 1 | 0;
    }
  }
  var match$1 = DataWindowSettings$ReactHooksTemplate.initialFocus(settings);
  if (match$1 === "FirstWindow") {
    if (DataWindowSettings$ReactHooksTemplate.size(settings) < dataLength) {
      return DataWindowSettings$ReactHooksTemplate.size(settings) - 1 | 0;
    } else {
      return dataLength - 1 | 0;
    }
  } else if (dataLength === 0) {
    return 0;
  } else {
    return dataLength - 1 | 0;
  }
}

function show(chartAttribute, enlarged, containerWidth) {
  var dataLength = GenericChartAttribute$ReactHooksTemplate.dataLength(chartAttribute);
  var isFullWidth = Belt_Option.getWithDefault(GenericChartAttribute$ReactHooksTemplate.width(chartAttribute), "") === "w-full";
  var baseWidth = isFullWidth ? 600 : 100;
  var resizedWidth = containerWidth < 1280 ? (
      isFullWidth ? baseWidth - 100 | 0 : baseWidth - 10 | 0
    ) : baseWidth + 100 | 0;
  var x = isFullWidth ? ((containerWidth - resizedWidth | 0) / 2 | 0) - 60 | 0 : (((containerWidth / 2 | 0) - resizedWidth | 0) / 2 | 0) - 50 | 0;
  var settings = enlarged ? DataWindowSettings$ReactHooksTemplate.expandedSettings(GenericChartAttribute$ReactHooksTemplate.dataWindowSettings(chartAttribute)) : DataWindowSettings$ReactHooksTemplate.defaultSettings(GenericChartAttribute$ReactHooksTemplate.dataWindowSettings(chartAttribute));
  return JsxRuntime.jsx(Recharts.Brush, {
              dataKey: AxisData$ReactHooksTemplate.key(GenericChartAttribute$ReactHooksTemplate.xAxis(chartAttribute)),
              startIndex: startIndex(settings, dataLength),
              endIndex: endIndex(settings, dataLength),
              height: enlarged ? 20 : 10,
              width: enlarged ? 600 : resizedWidth,
              x: enlarged ? ((containerWidth - 600 | 0) / 2 | 0) - 40 | 0 : x
            });
}

exports.show = show;
/* recharts Not a pure module */
